export enum ReportFormat {
    Analytic = 0,
    Synthetic = 1
}
export const ReportFormatLabel = new Map<number, string>([
    [ReportFormat.Analytic, 'Analítico'],
    [ReportFormat.Synthetic, 'Sintético']
]);
